import { Injectable } from '@angular/core';
import { EnumHelpers as NonNgEnumHelpers } from 'core/src/app/common/services/enum-helpers';

@Injectable({ providedIn: 'root' })
export class EnumHelpers extends NonNgEnumHelpers { }
